import React from "react";

const BoardDropIndicator: React.FC = () => (
  <div className="relative h-1 my-1">
    <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-0.5 bg-warm-blue rounded-full" />
    <div className="absolute -left-0.5 top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-warm-blue rounded-full" />
    <div className="absolute -right-0.5 top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-warm-blue rounded-full" />
  </div>
);

export default BoardDropIndicator;
